export default {
  error: 'Failed to start procedure',
  missingInfo: 'Information is missing',
  missingInfoDescription: 'Please select targets before accessing this page.',
  selectedCount: '{{count}} selected',
  startPackage: 'Start {{packageTypeName}}',
  success: 'Procedure started successfully',
  title: '{{packageTypeName}} - Set Anchor Date',
  titleWithTagName: '{{packageTypeName}} - Set Title and Anchor Date'
};